import { EditedReportRuleType } from "@/components/config-modals/players-reporter/report-rule/types";

//Use constants from router config (router-edit-modal)

export const formInitState: EditedReportRuleType = {
  name: "",
  authGroups: [],
  auth_groups: new Set(),
  enabled: true,
  data: {
    display_name: "",
    pattern: [],
    limits: [],
    replay: false,
    amount: 0,
    frequency: 0,
  },
};
